import React, {Component} from 'react';

class Error404 extends Component{
 
    render(){
        return(
            <div>
                <h1>Página no encontrada</h1>
            </div>
        );
    }
}

export default Error404